import priceListResource from "../resources/priceListResource";
import PriceList from "../domain/priceList";

export default {
  newPriceList() {
    return new PriceList({items: []});
  },
  async findAll () {
    const response = await priceListResource.query();
    if (response.ok) {
      return response.data.map((priceListData) => new PriceList(priceListData));
    } else {
      return null;
    }
  },
  async findCurrent (customerId) {
    const response = await priceListResource.current({customerId: customerId});
    if (response.ok && response.data) {
      return new PriceList(response.data);
    } else {
      return null;
    }
  },
  async create (priceList) {
    return priceListResource.save({}, priceList);
  },
  async update (priceList) {
    return priceListResource.update({}, priceList);
  },
  async delete(id) {
    return priceListResource.delete({id: id});
  },
  async deactivate (id) {
    return priceListResource.deactivate({id: id}, {});
  }
}



// WEBPACK FOOTER //
// ./client/services/priceListService.js